import { render, staticRenderFns } from "./productMeansDetail.vue?vue&type=template&id=28496984&scoped=true&"
import script from "./productMeansDetail.vue?vue&type=script&lang=js&"
export * from "./productMeansDetail.vue?vue&type=script&lang=js&"
import style0 from "./productMeansDetail.vue?vue&type=style&index=0&id=28496984&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28496984",
  null
  
)

export default component.exports